import { PayloadAction } from "@reduxjs/toolkit";

import { InfoDataState } from "./info-data-types";

const INFO_NAMESPACE = "@infoData";

export const SET_INFO_DATA = `${INFO_NAMESPACE}/SET_INFO_DATA`;

export const setInfoData = (
  info_data: Partial<InfoDataState>
): PayloadAction<Partial<InfoDataState>> => {
  return {
    type: SET_INFO_DATA,
    payload: info_data,
  };
};
